
export default function Footer() {
  return (
    <footer className="bg-red-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Somukoi
            </h3>
            <p className="text-red-100 leading-relaxed mb-6 max-w-md">
              Empowering communities through citizen journalism. Every voice matters, every story counts in building a stronger Northeast India.
            </p>
            <div className="flex gap-4">
              <button className="w-10 h-10 bg-red-800 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-red-800 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-red-800 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-youtube-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-red-800 hover:bg-red-700 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Blogs
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Contact
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Register
                </button>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Categories</h4>
            <ul className="space-y-3">
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Culture & Heritage
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  People & Communities
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Youth & Innovation
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Micro-Knowledge
                </button>
              </li>
              <li>
                <button className="text-red-100 hover:text-white transition-colors duration-300 cursor-pointer">
                  Local News
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-red-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-red-100 text-sm">
            © 2025 Somukoi. Powered by Xpec Innovations Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6 mt-4 md:mt-0">
            <button className="text-red-100 hover:text-white text-sm transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </button>
            <button className="text-red-100 hover:text-white text-sm transition-colors duration-300 cursor-pointer">
              Terms of Service
            </button>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-red-100 hover:text-white text-sm transition-colors duration-300"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
